import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import PaymentStripe from 'containers/Payment/Stripe'
import PaymentPayPal from 'containers/Payment/PayPal'
import { getCurrentUserPaymentTypeSettingsSelector } from 'modules/settings/selectors'
import { SETTINGS_MODEL_PAYMENT_TYPE } from 'models/daos/settings/constants'
import { View } from 'components/View'

class PaymentComponent extends React.Component {
  renderStripe () {
    const isSelected = (
      !this.props.paymentType ||
      this.props.paymentType === SETTINGS_MODEL_PAYMENT_TYPE.STRIPE
    )
    return <PaymentStripe isSelected={isSelected} />
  }

  renderPayPal () {
    const isSelected = (
      this.props.paymentType === SETTINGS_MODEL_PAYMENT_TYPE.PAY_PAL
    )
    return <PaymentPayPal isSelected={isSelected} />
  }

  render () {
    return (
      <View style={{ width: '100%' }}>
        {this.renderStripe()}
        {this.renderPayPal()}
      </View>
    )
  }
}

PaymentComponent.propTypes = {
  paymentType: PropTypes.oneOf(
    Object.values(SETTINGS_MODEL_PAYMENT_TYPE)
  )
}

const select = () => createSelector(
  getCurrentUserPaymentTypeSettingsSelector(),
  (
    paymentType
  ) => ({
    paymentType
  })
)

const Payment = connect(select)(PaymentComponent)

export default Payment
